import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cover-auth" }
const _hoisted_2 = { class: "widget-auth" }
const _hoisted_3 = { class: "flex gap-4 mb-7" }
const _hoisted_4 = ["id", "onUpdate:modelValue", "onInput", "onKeydown"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "text-primary-color text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createStaticVNode("<a href=\"#\" data-v-f80f1e76><div class=\"text-center mb-8\" data-v-f80f1e76><img src=\"/public/images/logo-wide.svg\" class=\"auth-logo\" data-v-f80f1e76></div></a><h2 class=\"font-semibold text-center my-6\" data-v-f80f1e76>Entrez le code de connexion</h2><p class=\"text-read text-grey-600 text-center pb-5\" data-v-f80f1e76> Un code de connexion a été envoyé à votre adresse e-mail, sur WhatsApp, et par SMS. </p>", 3)),
      _createElementVNode("form", {
        class: "form",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otpCode, (digit, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
              key: index,
              type: "text",
              class: "form-control-code",
              id: `otp-${index}`,
              "onUpdate:modelValue": ($event: any) => ((_ctx.otpCode[index]) = $event),
              maxlength: "1",
              onInput: ($event: any) => (_ctx.handleInput(index, $event)),
              onKeydown: ($event: any) => (_ctx.handleKeydown(index, $event)),
              onPaste: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
              placeholder: "",
              inputmode: "numeric",
              pattern: "[0-9]"
            }, null, 40, _hoisted_4)), [
              [_vModelText, _ctx.otpCode[index]]
            ])
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn lg w-100 flex-center mt-5 mb-7",
          disabled: !_ctx.isCodeComplete
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: "/public/icons/icon-menu-securite.svg",
            class: "btn-icon",
            alt: ""
          }, null, -1),
          _createElementVNode("span", null, "Valider", -1)
        ]))], 8, _hoisted_5),
        _createElementVNode("a", {
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendOtp && _ctx.resendOtp(...args)), ["prevent"])),
          class: "cursor-pointer"
        }, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.isResending ? 'Envoi en cours...' : 'Vous n\'avez pas reçu votre code ?'), 1)
        ])
      ], 32)
    ])
  ]))
}